import { useTakeoverContext } from 'modules/sendingPlatforms/contexts';
import { NavBar } from 'ui/takeOver';

export const TAKEOVER_NAVBAR_TEST_ID = 'takeover-navbar';

export const TakeoverNavBar = () => {
  const { closeTakeover } = useTakeoverContext();

  return (
    <NavBar
      id={TAKEOVER_NAVBAR_TEST_ID}
      onBackClick={closeTakeover}
      title="View account details"
      showChatButton
    />
  );
};
